// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Highlighted day with blue background */
.highlighted-day {
  background-color: rgb(62, 110, 222) !important;
  color: white !important;
  height: 100%;
}

/* Optional: Add a hover effect for highlighted days */
.highlighted-day:hover {
  background-color: rgb(133, 147, 171);
}

/* Task count styling */
.task-count {
  font-size: 0.8rem;
  color: white; /* Ensure contrast on blue background */
  text-align: center;
}


.action-button-with-outline{
  padding: 2px 3px;
  margin-right: 5px;
  border: none; 
  background-color: transparent;
  color: rgb(236, 134, 26);

  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}

.action-button-with-outline:hover {
  background-color: rgba(31, 124, 80, 0.12);
  color: #1f7c50;
}

.action-button:hover {
  background-color: rgba(31, 124, 80, 0.15);
  color: #1f7c50;
}

.submit-button {
    
  border: none;
  background-color: #ff6f61;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  outline: none;
  height: 30px !important;
  padding: 0px 10px;
}

.submit-button:hover {
  outline: none;
  background-color: #e65c54;
}

.submit-button2 {
  
  border: none;
  background-color: #fff;
  color: #ff6f61;
  border-radius: 5px;
  border: 1px solid #ff6f61;
  cursor: pointer;
  transition: background-color 0.3s ease;
  outline: none;
  height: 30px !important;
}



.submit-button2:hover {
  background-color: #ff6f61;
  color: white;
}


.btn_complete_model-warning {
  background-color: #ff6f61;
  outline: none !important;
  border: none;

  color: white !important;
  
}

.btn_complete_model-warning:hover {
  background-color: #cb720b !important;
  color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DashboardImplementor/component/calender.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,8CAA8C;EAC9C,uBAAuB;EACvB,YAAY;AACd;;AAEA,sDAAsD;AACtD;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;EACE,iBAAiB;EACjB,YAAY,EAAE,uCAAuC;EACrD,kBAAkB;AACpB;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,wBAAwB;;EAExB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,uBAAuB;AACzB;;;;AAIA;EACE,yBAAyB;EACzB,YAAY;AACd;;;AAGA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;;EAEZ,uBAAuB;;AAEzB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB","sourcesContent":["/* Highlighted day with blue background */\r\n.highlighted-day {\r\n  background-color: rgb(62, 110, 222) !important;\r\n  color: white !important;\r\n  height: 100%;\r\n}\r\n\r\n/* Optional: Add a hover effect for highlighted days */\r\n.highlighted-day:hover {\r\n  background-color: rgb(133, 147, 171);\r\n}\r\n\r\n/* Task count styling */\r\n.task-count {\r\n  font-size: 0.8rem;\r\n  color: white; /* Ensure contrast on blue background */\r\n  text-align: center;\r\n}\r\n\r\n\r\n.action-button-with-outline{\r\n  padding: 2px 3px;\r\n  margin-right: 5px;\r\n  border: none; \r\n  background-color: transparent;\r\n  color: rgb(236, 134, 26);\r\n\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n.action-button-with-outline:hover {\r\n  background-color: rgba(31, 124, 80, 0.12);\r\n  color: #1f7c50;\r\n}\r\n\r\n.action-button:hover {\r\n  background-color: rgba(31, 124, 80, 0.15);\r\n  color: #1f7c50;\r\n}\r\n\r\n.submit-button {\r\n    \r\n  border: none;\r\n  background-color: #ff6f61;\r\n  color: white;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  outline: none;\r\n  height: 30px !important;\r\n  padding: 0px 10px;\r\n}\r\n\r\n.submit-button:hover {\r\n  outline: none;\r\n  background-color: #e65c54;\r\n}\r\n\r\n.submit-button2 {\r\n  \r\n  border: none;\r\n  background-color: #fff;\r\n  color: #ff6f61;\r\n  border-radius: 5px;\r\n  border: 1px solid #ff6f61;\r\n  cursor: pointer;\r\n  transition: background-color 0.3s ease;\r\n  outline: none;\r\n  height: 30px !important;\r\n}\r\n\r\n\r\n\r\n.submit-button2:hover {\r\n  background-color: #ff6f61;\r\n  color: white;\r\n}\r\n\r\n\r\n.btn_complete_model-warning {\r\n  background-color: #ff6f61;\r\n  outline: none !important;\r\n  border: none;\r\n\r\n  color: white !important;\r\n  \r\n}\r\n\r\n.btn_complete_model-warning:hover {\r\n  background-color: #cb720b !important;\r\n  color: #fff !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
